package co.maytes.standupbot.dashboard.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import org.jetbrains.compose.web.css.CSSMediaQuery

private val forcedColors = CSSMediaQuery.Raw("(forced-colors: active)")

@InitSilk
fun initDesignSystemStyles(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyle(".${Typography.TABULAR_CLASS}") {
        base {
            Modifier.styleModifier {
                property("font-variant-numeric", "tabular-nums")
                property("font-feature-settings", "\"tnum\" 1")
            }
        }
    }

    ctx.stylesheet.registerStyle(".${FocusRing.VISIBLE_CLASS}") {
        cssRule(":focus-visible") { Modifier.focusRingOutline() }
    }

    ctx.stylesheet.registerStyle(".${FocusRing.ALWAYS_CLASS}") {
        cssRule(":focus") { Modifier.focusRingOutline() }
    }

    ctx.stylesheet.registerStyle("*") {
        cssRule(forcedColors, ":focus-visible") {
            Modifier.styleModifier { property("outline-color", "Highlight") }
        }
    }
}
